export default __webpack_public_path__ + "static/media/swap-coin.31cd63cd.png";